import { render, staticRenderFns } from "./Leave_old.vue?vue&type=template&id=3c121004"
import script from "./Leave_old.vue?vue&type=script&lang=js"
export * from "./Leave_old.vue?vue&type=script&lang=js"
import style0 from "./Leave_old.vue?vue&type=style&index=0&id=3c121004&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports